/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tooltip } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import React, { useEffect, useMemo, useState } from "react";

import { Check } from "@mui/icons-material";
import DataGrid from "../dataTable";
import TextField from "../hookForms/textField";
import messages from "../../utils/messages";
import serviceClienteInstalacao from "../../services/serviceClienteInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    returnData?: any;
    onClose?: any;
    data: {
        open: boolean;
        nomeCliente: string;
        instalacaoID: number;
        numeroInstalacao: string;
        clienteInstalacaoID?: number;
    };
}

const PersonSearch: React.FC<IDialogProps> = ({ data, onClose, returnData }: IDialogProps) => {
    const [list, setList] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [rowCount, setRowCount] = useState(0);
    const [filters, setFilters] = useState<any>();
    const [isLoading, setLoading] = useState(false);
    const [page, setPage] = useState(0);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 120,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Selecionar">
                                <Check />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() => {
                            returnData({
                                clienteInstalacaoID: params.row.clienteInstalacaoID,
                                numeroInstalacao: params.row.numeroInstalacao,
                                nomeCliente: params.row.nomeCliente,
                                clienteID: params.row.clienteID,
                            });
                            onClose();
                        }}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "clienteInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Nome do Cliente",
                field: "nomeCliente",
                type: "string",
                width: 280,
            },
            {
                headerName: "Cpf/Cnpj",
                field: "numeroDocumentoClienteFormatado",
                type: "string",
                width: 160,
            },
            {
                headerName: "Parceiro",
                field: "nomeParceiro",
                type: "string",
                width: 70,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Desconto %",
                field: "percentualDescontoContratado",
                type: "string",
                width: 100,
            },
            {
                headerName: "Habilitado",
                field: "flagHabilitado",
                type: "string",
                width: 70,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm();

    const getAllWithFilters = async (e: any) => {
        setLoading(true);
        setList([]);

        serviceClienteInstalacao
            .getWithFilter({
                ...e,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setList(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setList([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        if (data.open && data.numeroInstalacao) {
            reset(data);
            getAllWithFilters({ numeroInstalacao: data.numeroInstalacao });
        }
    }, [data]);

    const onSubmit = (values, event) => {
        event.preventDefault();

        delete values.open;
        delete values.instalacaoID;
        delete values.numeroInstalacao;

        const newFilters = {
            ...values,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    return (
        <Dialog fullWidth={true} maxWidth="lg" open={data.open}>
            <DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} display="flex" alignItems="center">
                        <Grid item md={11}>
                            <TextField
                                id="nomeCliente"
                                name="nomeCliente"
                                label="Cliente"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={1}>
                            <Button
                                id="buscar"
                                onClick={handleSubmit(onSubmit)}
                                variant="contained"
                                color="primary"
                                disableElevation
                            >
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ height: 450, mt: 3 }}>
                    <DataGrid
                        columns={columns}
                        rows={list}
                        rowId={(row: GridRowModel) => row.clienteInstalacaoID}
                        rowCount={rowCount}
                        isLoading={isLoading}
                        onPageChange={(currentPage: number) => setPage(currentPage)}
                        onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                        pageSize={pageSize}
                        onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                    />
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    variant="contained"
                    color="warning"
                    onClick={onClose}
                    style={{ width: "159px", height: "44px" }}
                >
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PersonSearch;
